<div class="dialog-container">
  <p *ngIf="message">{{ message }}</p>
  <br>
  <p *ngIf="fascicoliSecondari.length > 0">Seleziona un nuovo fascicolo principale per continuare:</p>

  <ul *ngIf="fascicoliSecondari.length > 0">
    <li *ngFor="let fasc of fascicoliSecondari; trackBy: trackByFascicolo">
        <div class="form-group col-sm-12 listcheckbox">
          <div style="display: flex;">
            <input [checked]="fascicoloSelezionato === fasc" (change)="selezionaFascicolo(fasc)" type="checkbox" id="select-fasc-lbl" >
            <label for="select-fasc-lbl">
              <small class="sr-only">Seleziona fascicolo con posizione {{ fasc.posizioneFascicolo }}</small>
            </label>
            <strong>{{ fasc.posizioneFascicolo }}</strong>
          </div>
        </div>
    </li>
  </ul>
  <br>
  <div class="row">
    <div class="col-xs-6 col-sm-2">
      <button type="button" role="button" class="btn btn-secondary btn-block" (click)="annulla()">Annulla</button>
    </div>
    <div class="col-xs-6 col-sm-2 col-sm-offset-8">
      <button type="button" role="button" class="btn btn-primary btn-block" (click)="confermaSelezione()" [disabled]="!fascicoloSelezionato">Continua</button>
    </div>
  </div>
</div>
